import newsImageFallback from "../../design_system/icons/extras/news-image-fallback.svg";

export const handleNewsImageError = (event) => {
    event.currentTarget.onerror = null;
    event.currentTarget.src = newsImageFallback;
};
